export default "__VITE_ASSET__B0E3l$is__"